module.exports = __webpack_public_path__ + "img/1-1.3ddf985.svg";